import React from 'react';
import { observer, inject } from "mobx-react"

import Countdown from 'react-countdown';

export const CountDown = inject("store")(observer((props) => {

    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            //props.store.setOdemeSuresiDolduMenuDisplay(true)
            //props.store.setOdemeBilgilendirmeMenuDisplay(false)
            return <span>Süre Doldu.</span>;
        } else {
            // Render a countdown
            return <span>{minutes}:{seconds}</span>;
        }
    };

    console.log("Date.now() + 180000: ", Date.now() + 180000)
    console.log("props.date: ", new Date(props.date).getTime())

    return (
        <>
            <span><b>Kalan Süre:</b> <Countdown date={new Date(props.date).getTime() + Number(props.time)} renderer={renderer} /> </span>
        </>
    )
}))